import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../components/icons'
import Text from '../../../../elements/Typo/Text'

import { ExperimentDetailsI } from '../../../../_config/types'
import { trackEvent } from '../../../../_common/functions'
import { useExperimentApi } from '../../../../store/api/hooks/experimentApiHook'
import { useFpLoader } from '../../../../store/api/hooks/fpLoaderHook'
import toast from 'react-hot-toast'
import { URLS } from '../../../../_config'

interface Props {
    experiment: ExperimentDetailsI
}
const DownloadFiles: React.FC<Props> = ({ experiment }) => {
    const { t } = useTranslation()
    const dropdownRef = useRef<HTMLDivElement>(null)
    const [showDropdown, setShowDropdown] = useState<boolean>(false)
    const experimentApi = useExperimentApi()
    const { showLoader, hideLoader } = useFpLoader()
    const downloadZip = () => {
        showLoader()
        experimentApi.downloadLog(
            { literal: experiment.experiment_literal },
            (response: any) => {
                hideLoader()
                console.log('Files downloaded successfully:', response)
                const blob = new Blob([response], { type: 'application/zip' })

                const url = globalThis.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `experiment_${experiment.experiment_literal}_logs.zip`)
                document.body.appendChild(link)
                link.click()
                link.remove()
                globalThis.URL.revokeObjectURL(url)
            },
            (error) => {
                hideLoader()
                console.error('Error downloading files:', error)
                toast.error(t('Failed to download files. Please try again later.'))
            },
        )
    }

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowDropdown(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <div ref={dropdownRef} className="relative">
            <button type="button" onClick={() => setShowDropdown(true)} className="flex gap-[0.33rem] bg-[#FFF] rounded-[1.667rem] items-center" data-aos="zoom-in" data-aos-delay="200" data-testid="dbtn">
                <div data-testid="share-button" aria-label={t('Download')} className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center cursor-pointer">
                    <Icon name="download-alt1" size={'0.545rem'}></Icon>
                </div>
                <Text size="xs" className="!text-[0.591rem] !font-semibold">
                    {t('Download')}
                </Text>
            </button>
            {showDropdown && (
                <div className="absolute bg-white border px-2 rounded-lg shadow-1 w-32 z-10 py-1" style={{ right: -4 }}>
                    <div className="border-b-0.5 border-b border-slate-300 flex py-1">
                        <button
                            type="button"
                            className=""
                            onClick={() => {
                                trackEvent('experiment_details_download_pdf', { experiment_literal: experiment?.experiment_literal, experiment_name: experiment?.experiment_name })
                                window.open(URLS.EXPERIMENT_DETAILS_DOWNLOAD(experiment?.experiment_literal), '_blank')
                            }}
                        >
                            <Text size="13" className="font-normal !text-[0.545rem]">
                                {t('Download PDF')}
                            </Text>
                        </button>
                    </div>
                    <div className="flex py-1">
                        <button
                            type="button"
                            onClick={() => {
                                trackEvent('experiment_details_download_csv', { experiment_literal: experiment?.experiment_literal, experiment_name: experiment?.experiment_name })
                                downloadZip()
                            }}
                        >
                            <Text size="13" className="font-normal !text-[0.545rem]">
                                {t('Download CSV')}
                            </Text>
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
export default DownloadFiles
